import React from "react";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Input } from "../../../../../design/input";
import { Textarea } from "../../../../../design/textarea";
import { Professional } from "../../../../../models/Professional";

const OnboardingBioAndAvatarStep: React.FC<{
  formData: Partial<Professional>;
  setFormData: React.Dispatch<React.SetStateAction<Partial<Professional>>>;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ formData, setFormData, onBack, onStepComplete }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer title="Bio and Profile Picture">
      <>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Field>
            <Label>Short Bio</Label>
            <Textarea
              rows={6}
              value={formData.bio || ""}
              onChange={(e) =>
                setFormData({ ...formData, bio: e.target.value })
              }
              placeholder="Tell potential clients about your background, approach, and what makes you unique."
            />
          </Field>

          <Field>
            <Label>Website URL</Label>
            <Input
              type="url"
              value={formData.websiteUrl || ""}
              onChange={(e) =>
                setFormData({ ...formData, websiteUrl: e.target.value })
              }
              placeholder="https://yourwebsite.com"
            />
          </Field>

          <Field>
            <Label>Scheduling URL</Label>
            <Input
              type="url"
              value={formData.schedulingUrl || ""}
              onChange={(e) =>
                setFormData({ ...formData, schedulingUrl: e.target.value })
              }
              placeholder="https://yourwebsite.com/schedule"
            />
          </Field>

          <div className="flex justify-between gap-4">
            <Button type="button" onClick={onBack}>
              Back
            </Button>
            <Button type="submit">Continue</Button>
          </div>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingBioAndAvatarStep;
